module.exports = __webpack_public_path__ + "img/investment_green.94b592c0.svg";